import api from "@/api";

const PlaylistModule = {
    state: () => ({ all: [], single: null, isLoading: false }),
    mutations: {
        ADD_ALL_PLAYLISTS(state, payload) {
            state.all.splice(0, state.all.length, ...payload);
        },
        UPDATE_SINGLE_PLAYLIST(state, payload) {
            console.log(payload)
            state.single = payload;
        },
    },
    actions: {
        async getAllPlaylists(context) {
            const content = await api.PodcastApi.getAll();
            context.commit("ADD_ALL_PLAYLISTS", content.data);
        },
        async getSignlePlaylist(context, payload) {
            const content = await api.PodcastApi.getSingle(payload);
            context.commit("UPDATE_SINGLE_PLAYLIST", content.data);
        },
    },
    getters: {},
    namespaced: true,
};
export default PlaylistModule;